import styled, { keyframes } from 'styled-components'
import { TextButton } from '@amzn/storm-ui'
import { MediaContainer as CommonMediaContainer } from '../../../../common/components/MediaContainer'
import { fadeIn, fadeOut } from '../../commons/styles'

export const progressFadeInFrames = keyframes`
0% { opacity: 0 }
20% { opacity: 0 }
80% { opacity: 0 }
100% { opacity: 1 }
`

const load = keyframes`
  0% { width: 0 }
  100% { width: 100% }
`

export const CarouselProgressPillContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: ${({ theme }) => theme.spacing.mini} 0;
  padding-top: 2px;
`
export const FadeInContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

//animation: 2s ease 0s normal forwards 1 ${progressFadeInFrames};
export const ProgressFadeInContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.spacing.xxlarge};
`

export const PlayPauseContainer = styled.div`
  margin-right: 16px;
  text-align: center;
`

export const PlayPauseButton = styled(TextButton)`
  color: ${({ theme }) => theme.palette.white};
  &:hover {
    color: ${({ theme }) => theme.palette.white};
  }
`

export const SlideContainer = styled.div<{ isActive: boolean; isFirstSlide: boolean; isLastSlide: boolean }>`
  display: ${({ isActive }) => (isActive ? 'flex' : 'none')};
  justify-content: space-between;
  margin: 44px ${({ isLastSlide }) => (isLastSlide ? '110px' : 0)} 44px ${({ isFirstSlide }) => (isFirstSlide ? '110px' : 0)};
  height: 350px;
  ${({ isActive }) => (isActive ? fadeIn : fadeOut)};
`

export const ProgressPillContainer = styled(TextButton)`
  display: inline-block;
  position: relative;
  width: 50px;
  height: 4px;
  border-radius: 2px;
  margin-right: ${({ theme }) => theme.spacing.mini};

  &:hover {
    background-color: ${({ theme }) => theme.palette.white};
  }

  &:last-child {
    margin-right: 0;
  }

  &::before {
    content: '';
    background-color: ${({ theme }) => theme.palette.white};
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    opacity: 30%;
  }
`

export const ProgressDiv = styled.div`
  background: rgba(255, 255, 255, 0.1);
  justify-content: flex-start;
  border-radius: 100px;
  align-items: center;
  position: relative;
  padding: 0 5px;
  display: flex;
  height: 40px;
  width: 500px;
`

export const ProgressPillActive = styled.div<{ duration: number }>`
  display: block;
  position: relative;
  height: 4px;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.palette.white};
  animation: ${load} ${({ duration }) => duration}ms normal forwards;
  width: 0;
`

export const ProgressPillUnread = styled.div`
  display: block;
  position: relative;
  height: 4px;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.palette.white};
  width: 0;
`

export const ProgressPillComplete = styled.div`
  display: block;
  position: relative;
  height: 4px;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.palette.white};
  width: 100%;
`

export const MediaContainer = styled(CommonMediaContainer)`
  margin: 0 0 0 30px;
`
